var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelDuration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.54 23.08C19.7042 23.08 23.08 19.7042 23.08 15.54C23.08 11.3758 19.7042 8 15.54 8C11.3758 8 8 11.3758 8 15.54C8 19.7042 11.3758 23.08 15.54 23.08Z",
    fill: "#DDDDDF",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.54 21.46C18.8096 21.46 21.46 18.8095 21.46 15.54C21.46 12.2705 18.8096 9.62 15.54 9.62C12.2705 9.62 9.62003 12.2705 9.62003 15.54C9.62003 18.8095 12.2705 21.46 15.54 21.46Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.54 10.54L15.54 15.54",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.54 13.54L15.54 15.54",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelDuration);
export default __webpack_public_path__ + "static/media/SelDuration.5595e2c80914e6ab8d5da8ea6e6f48e9.svg";
export { ForwardRef as ReactComponent };